import React, { useState, useCallback, lazy, Suspense } from "react"
import { I18n } from "utils/i18n-shim"
import { Box, useTheme } from "@mui/material"
import get from "lodash/get"
import keys from "lodash/keys"
import size from "lodash/size"
import isString from "lodash/isString"
import head from "lodash/head"

const SummernoteEditor = lazy(() => import("shared/ui/SummernoteEditor"))

const defaultErrorSx = {
  fontSize: 12,
  lineHeight: "12px",
  color: "red"
}

const Wysiwyg = ({
  label,
  className,
  error = {},
  errorLabels = {},
  dirty = false,
  useVisitedInsteadOfTouched,
  visited,
  errorStyle,
  value,
  placeholder,
  disabled,
  onChange,
  onFocus,
  onBlur,
  touched: touchedProp = false
}) => {
  const [isFocused, setIsFocused] = useState(false)
  const [touched, setTouched] = useState(touchedProp)

  const onFocusHandler = useCallback(() => {
    setIsFocused(true)
    setTouched(true)
    onFocus?.()
  }, [onFocus])

  const onBlurHandler = useCallback(() => {
    setIsFocused(false)
    onBlur?.()
  }, [onBlur])

  const theme = useTheme()
  const errors = keys(error)
  const touchedOrVisited = useVisitedInsteadOfTouched ? visited : touched
  let errorKey = ""
  if ((dirty || touchedOrVisited) && size(errors) && !isFocused) {
    errorKey = isString(error) ? error : head(errors)
  }

  const errorText = !errorKey
    ? ""
    : get(errorLabels, errorKey, I18n.t(`errors.${errorKey}`))
  return (
    <Box
      sx={{
        borderBottom: isFocused
          ? `2px solid ${theme.palette.primary.main}`
          : "1px solid rgb(224, 224, 224)",
        marginBottom: "10px"
      }}
      className={`${className} fieldContainer multiLine`}
    >
      <Box
        component="label"
        className="wysiwyg-label"
        sx={isFocused ? { color: theme.palette.primary.main } : undefined}
      >
        {label}
      </Box>
      <Suspense fallback={null}>
        <SummernoteEditor
          value={value}
          onChange={onChange}
          onFocus={onFocusHandler}
          onBlur={onBlurHandler}
          placeholder={placeholder}
          disabled={disabled}
        />
      </Suspense>
      <Box sx={{ ...defaultErrorSx, ...errorStyle }}>{errorText}</Box>
    </Box>
  )
}

export default Wysiwyg
